function sfc32(a, b, c, d) {
    return function () {
        a >>>= 0;
        b >>>= 0;
        c >>>= 0;
        d >>>= 0;
        var t = (a + b) | 0;
        a = b ^ b >>> 9;
        b = c + (c << 3) | 0;
        c = (c << 21 | c >>> 11);
        d = d + 1 | 0;
        t = t + d | 0;
        c = c + t | 0;
        return (t >>> 0) / 4294967296;
    }
}

function xmur3(str) {
    for (var i = 0, h = 1779033703 ^ str.length; i < str.length; i++) {
        h = Math.imul(h ^ str.charCodeAt(i), 3432918353);
        h = h << 13 | h >>> 19;
    }
    return function () {
        h = Math.imul(h ^ (h >>> 16), 2246822507);
        h = Math.imul(h ^ (h >>> 13), 3266489909);
        return (h ^= h >>> 16) >>> 0;
    }
}

let rand;
export let seed = (seed) => {
    let gen = xmur3(seed);
    rand = sfc32(gen(), gen(), gen(), gen());
}


function randomChoice(arr) {
    return arr[Math.floor(arr.length * rand())];
}

export let loadWords = async (path) => fetch(path)
    .then(response => response.text()).then(t => {
        let a = t.split('\n').map(w => w.toLowerCase());
        a.pop();
        return a.sort(); // Add this line
    })


let solveCover = (Y) => {
    // Y is a list of list of elements
    let X = new Map();
    for (let y of Y) {
        for (let x of y) {
            if (!X.has(x))
                X.set(x, new Set());
            X.get(x).add(y);
        }
    }
    let solution = new Array();
    let rec = () => {
        if (X.size == 0)
            return solution;
        let c = X.keys().next().value;
        for (const x of X.keys()) {
            if (X.get(x).size < X.get(c).size)
                c = x;
        }
        for (let r of X.get(c)) {
            solution.push(r);
            let cols = select(X, r);
            let ans = rec();
            if (ans) return ans;
            deselect(X, r, cols)
            solution.pop();
        }
        return false;
    }
    return rec();
}

let select = (X, r) => {
    let cols = new Array();
    for (let j of r) {
        for (let i of X.get(j))
            for (let k of i)
                if (k != j)
                    X.get(k).delete(i);
        cols.push(X.get(j)), X.delete(j);
    }
    return cols;
}
let deselect = (X, r, cols) => {
    for (let j of Array.from(r).reverse()) {
        X.set(j, cols.pop());
        for (let i of X.get(j))
            for (let k of i)
                if (k != j)
                    X.get(k).add(i);
    }
}


let unorderedTriples = (set) => {
    let ans = new Array();
    let ar = Array.from(new Set(set));
    for (let i = 0; i < ar.length; i++) {
        for (let j = i + 1; j < ar.length; j++) {
            for (let k = j + 1; k < ar.length; k++) {
                ans.push(ar[i] + ar[j] + ar[k]);

            }
        }
    }
    return ans;
}


let pairs = (set) => {
    let ar = Array.from(new Set(set));
    let ans = new Array();
    for (let i = 0; i < ar.length; i++) {
        for (let j = i + 1; j < ar.length; j++) {
            ans.push(ar[i] + ar[j]);

        }
    }
    return ans
}
let partition = (w1, w2) => {
    let w = w1 + w2.slice(1);
    let Y = new Array();
    for (let tri of unorderedTriples(w)) {
        if (pairs(tri).some(x => w.indexOf(x) != -1))
            continue;
        Y.push(tri);
    }
    return solveCover(Y);
}
let genPair = (words, wbfl, unique) => {
    while (1) {
        let w1 = randomChoice(words);
        let w2 = randomChoice(wbfl.get(w1.slice(-1)))
        if (new Set(w1 + w2).size == 12 && (!unique || (w1 + w2).length == 13))
            return [w1, w2];
    }
}
export let getDate = (day) => {
    if (!day)
        day = new Date();
    return (
        day.getFullYear() +
        "-" +
        (day.getMonth() + 1) +
        "-" +
        day.getDate()
    );
};

export let yesterday = () => {
    var date = new Date();
    date.setDate(date.getDate() - 1);
    return getDate(date);
}

export let randomPastDate = () => {
    const today = new Date();
    // Start date for puzzles can be set here.
    const startDate = new Date('2023-01-01');
    const diffTime = today.getTime() - startDate.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    // Pick a random number of days in the past.
    const randomDays = Math.floor(Math.random() * diffDays);
    const randomDate = new Date();
    randomDate.setDate(today.getDate() - randomDays);

    return randomDate.toISOString().slice(0, 10);
};

export let makeGenerate = (words) => {
    let wbfl = new Map();
    for (let w of words) {
        let c = w[0];
        if (!wbfl.has(c))
            wbfl.set(c, new Array());
        wbfl.get(c).push(w);
    }
    return (s) => {
        if (s)
            seed(s);
        while (true) {
            let [w1, w2] = genPair(words, wbfl, true);
            let puzzle = partition(w1, w2);
            if (puzzle)
                return puzzle;
        }
    }

}

export let makeCheck = (words) => (w) => {
    w = w.toLowerCase();
    let a = 0,
        b = words.length;
    while (b - a > 1) {
        let c = Math.floor((a + b) / 2);
        if (w < words[c])
            b = c;
        else
            a = c;
    }
    return w == words[a];
};

export let makeSolve = (words) => (puzzle) => {
    puzzle = puzzle.toLowerCase();
    let valid = (w) => {
        let lastSide = null;
        for (let c of w) {
            let i = puzzle.indexOf(c);
            if (i == -1) return false;

            // Determine which side this letter is on (0-3)
            let currentSide = Math.floor(i / 3);

            if (currentSide === lastSide) return false;
            lastSide = currentSide;
        }
        return true;
    }
    let ltp = new Map();
    for (let w of words) {
        if (!valid(w))
            continue;
        for (let [i, c] of [
            [0, w.slice(-1)],
            [1, w[0]]
        ]) {
            if (!ltp.has(c))
                ltp.set(c, [
                    [],
                    []
                ]);
            ltp.get(c)[i].push(w);
        }
    }
    let ans = [];
    for (let [l1, l2] of ltp.values()) {
        for (let w1 of l1) {
            for (let w2 of l2) {
                if ((w1 + w2).length == 13 && new Set(w1 + w2).size == 12)
                    ans.push([w1, w2]);
            }
        }
    }
    return ans;
}

// Add these functions to your litterboxed.js file

export function getStreakData() {
    if (typeof localStorage === 'undefined') return null;

    const streakData = localStorage.getItem('alphabox-streak');
    return streakData ? JSON.parse(streakData) : null;
}

export function updateStreak(wonToday = false) {
    if (typeof localStorage === 'undefined') return null;

    const today = getDate();
    const streakData = getStreakData() || { current: 0, lastPlayed: null, longest: 0 };

    let needsUpdate = false;

    // If we already played today, don't update unless we're marking a win
    if (streakData.lastPlayed === today) {
        if (wonToday && streakData.current === 0) {
            // Special case: if we lost earlier today but now won, update the streak
            streakData.current = 1;
            streakData.longest = Math.max(1, streakData.longest);
            needsUpdate = true;
        }
    } else {
        // Check if we're continuing a streak (played yesterday)
        const isConsecutive = streakData.lastPlayed === yesterday();

        if (wonToday) {
            // If won and consecutive day, increment streak
            if (isConsecutive) {
                streakData.current += 1;
            } else {
                // Otherwise start a new streak
                streakData.current = 1;
            }

            // Update longest streak if needed
            streakData.longest = Math.max(streakData.current, streakData.longest);
        } else {
            // Lost, reset streak
            streakData.current = 0;
        }

        // Update last played date
        streakData.lastPlayed = today;
        needsUpdate = true;
    }

    // Save to localStorage only if we made changes
    if (needsUpdate) {
        localStorage.setItem('alphabox-streak', JSON.stringify(streakData));
    }

    // Return a new object to ensure reactivity
    return { ...streakData };
}

export function shouldShowHelp() {
    const streakData = getStreakData();
    return !streakData || !streakData.lastPlayed;
}

